// API Configuration for PehchanPe and FinAnalyz services

export const API_CONFIG = {
  // PehchanPe API Configuration
  pehchanpe: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.pehchanpe.com',
    proxyURL: process.env.NODE_ENV === 'production' 
      ? '/api-pehchanpe'  // Use Netlify redirects in production
      : '/api-pehchanpe', // Use setupProxy.js in development
    apiKey: process.env.REACT_APP_PEHCHANPE_API_KEY || 'mk1_40341bc4.WOr-rV14T4cKpcySrp3ifSumXDo6VPK5',
    timeout: 3600000, // 1 hour for file processing
    headers: {
      'x-api-key': process.env.REACT_APP_PEHCHANPE_API_KEY || 'mk1_40341bc4.WOr-rV14T4cKpcySrp3ifSumXDo6VPK5',
      'Accept': '*/*'
    }
  }
};

// API Endpoints
export const ENDPOINTS = {
  // PehchanPe APIs
  pehchanpe: {
    // Bank Statement APIs
    parsePDF: '/v1/finalyze/parsePDF',
    getAllBankAccounts: '/v1/finalyze/getAllBankAccounts',
    analysis: '/v1/finalyze/analysis',
    transactions: '/v1/finalyze/transactions', // New endpoint for transaction-related data
    creditReport: '/v1/finalyze/creditReport',
    
    // Unified eKYC API
    ekyc: '/v1/finalyze/ekyc'
  }
};

// Service Categories
export const SERVICE_CATEGORIES = {
  BANK_STATEMENT: 'Bank Statement Analysis',
  CREDIT_BUREAU: 'Credit Bureau',
  EKYC: 'eKYC Verification'
};

// Supported Banks for PehchanPe (sorted alphabetically)
const BANKS_UNSORTED = [
  'KVB',
  'Axis Bank',
  'Bank of Baroda',
  'Bank of India',
  'Canara Bank',
  'CBOI',
  'Citi Bank',
  'DBS Bank',
  'ICICI Bank',
  'IDBI Bank',
  'IDFC Bank',
  'Indian Bank',
  'Karnataka Gramin Bank',
  'Punjab National Bank',
  'State Bank of India',
  'Tamilnadu Mercantile Bank Ltd. (TMB)',
  'Yes Bank',
  'Union Bank of India',
  'Karur Vysya Bank',
  'HDFC Bank',
  'Bank of Maharashtra',
  'Central Bank of India',
  'Indian Overseas Bank',
  'Punjab and Sind Bank',
  'UCO Bank',
  'Bandhan Bank',
  'CSB Bank',
  'City Union Bank',
  'DCB Bank',
  'Dhanlaxmi Bank',
  'Federal Bank',
  'IDFC First Bank',
  'India Post Payments Bank',
  'IndusInd Bank',
  'Jammu & Kashmir Bank',
  'Karnataka Bank',
  'Kotak Mahindra Bank',
  'Nainital Bank',
  'RBL Bank',
  'South Indian Bank',
  'The Andaman and Nicobar State Co-operative Bank Ltd.',
  'The Andhra Pradesh State Co-operative Bank Ltd.',
  'The Arunachal Pradesh State co-operative Apex Bank Ltd.',
  'The Assam Co-operative Apex Bank Ltd.',
  'The Bihar State Co-operative Bank Ltd.',
  'The Chandigarh State Co-operative Bank Ltd.',
  'The Chhattisgarh RajyaSahakari Bank Maryadit',
  'The Delhi State Co-operative Bank Ltd.',
  'The Goa State Co-operative Bank Ltd.',
  'The Gujarat State Co-operative Bank Ltd.',
  'The Haryana State Co-opertive Apex Bank Ltd.',
  'The Himachal Pradesh State Co-operative Bank Ltd.',
  'The Jammu and Kashmir State Co-operative Bank Ltd.',
  'The Jharkhand State cooperative bank ltd.',
  'The Karnataka State Co-operative Apex Bank Ltd.',
  'The Kerala State Co-operative Bank Ltd.',
  'The Madhya Pradesh Rajya Sahakari Bank Maryadit',
  'The Maharashtra State Co-operative Bank Ltd.',
  'The Manipur State Co-operative Bank Ltd.',
  'The Meghalaya Co-operative Apex Bank Ltd.',
  'The Mizoram Co-operative Apex Bank Ltd.',
  'The Nagaland State Co-operative Bank Ltd.',
  'The Orissa State Co-operative Bank Ltd.',
  'The Pondichery State Co-opertive Bank Ltd.',
  'The Punjab State Co-operative Bank Ltd.',
  'The Rajasthan State Co-operative Bank Ltd.',
  'The Sikkim State Co-operative Bank Ltd.',
  'The Tamil Nadu State Apex Co-operative Bank Ltd.',
  'The Telangana State Cooperative Apex Bank Ltd.',
  'The Tripura State Co-operative Bank Ltd.',
  'The Uttar Pradesh Co-operative Bank Ltd.',
  'The Uttaranchal Rajya Sahakari Bank Ltd.',
  'The West Bengal State Co-operative Bank Ltd.',
  'Andhra Pradesh Grameena Vikas Bank',
  'Andhra Pragathi Grameena Bank',
  'Chaitanya Godavari Gramin Bank',
  'Saptagiri Gramin Bank',
  'Arunachal Pradesh Rural Bank',
  'Assam Gramin Vikash Bank',
  'Dakshin Bihar Gramin Bank',
  'Uttar Bihar Gramin Bank',
  'Chhattisgarh Rajya Gramin Bank',
  'Baroda Gujarat Gramin Bank',
  'Saurashtra Gramin Bank',
  'Sarva Haryana Gramin Bank',
  'Himachal Pradesh Gramin Bank',
  'Ellaquai Dehati Bank',
  'Jammu And Kashmir Grameen Bank',
  'Jharkhand Rajya Gramin Bank',
  'Karnataka Vikas Grameena Bank',
  'Kerala Gramin Bank',
  'Madhya Pradesh Gramin Bank',
  'Madhyanchal Gramin Bank',
  'Maharashtra Gramin Bank',
  'Vidarbha Konkan Gramin Bank',
  'Manipur Rural Bank',
  'Meghalaya Rural Bank',
  'Mizoram Rural Bank',
  'Nagaland Rural Bank',
  'Odisha Gramya Bank',
  'Utkal Grameen Bank',
  'Puduvai Bharathiar Grama Bank',
  'Punjab Gramin Bank',
  'Rajasthan Marudhara Gramin Bank',
  'Baroda Rajasthan Kshetriya Gramin Bank',
  'Tamil Nadu Grama Bank',
  'Telangana Grameena Bank',
  'Tripura Gramin Bank',
  'Aryavart Bank',
  'Baroda UP Bank',
  'Prathama UP Gramin Bank',
  'Uttarakhand Gramin Bank',
  'Bangiya Gramin Vikash Bank',
  'Paschim Banga Gramin Bank',
  'Uttarbanga Kshetriya Gramin Bank',
  'ARAB NATIONAL BANK',
  'AU Small Finance Bank',
  'CITY Union Bank',
  'Andhra Bank'
];

// Export sorted bank names
export const SUPPORTED_BANKS = BANKS_UNSORTED.sort((a, b) => a.localeCompare(b));

// Indian States for various services
export const INDIAN_STATES = [
  { code: 'AP', name: 'Andhra Pradesh' },
  { code: 'AR', name: 'Arunachal Pradesh' },
  { code: 'AS', name: 'Assam' },
  { code: 'BR', name: 'Bihar' },
  { code: 'CT', name: 'Chhattisgarh' },
  { code: 'GA', name: 'Goa' },
  { code: 'GJ', name: 'Gujarat' },
  { code: 'HR', name: 'Haryana' },
  { code: 'HP', name: 'Himachal Pradesh' },
  { code: 'JK', name: 'Jammu and Kashmir' },
  { code: 'JH', name: 'Jharkhand' },
  { code: 'KA', name: 'Karnataka' },
  { code: 'KL', name: 'Kerala' },
  { code: 'MP', name: 'Madhya Pradesh' },
  { code: 'MH', name: 'Maharashtra' },
  { code: 'MN', name: 'Manipur' },
  { code: 'ML', name: 'Meghalaya' },
  { code: 'MZ', name: 'Mizoram' },
  { code: 'NL', name: 'Nagaland' },
  { code: 'OR', name: 'Odisha' },
  { code: 'PB', name: 'Punjab' },
  { code: 'RJ', name: 'Rajasthan' },
  { code: 'SK', name: 'Sikkim' },
  { code: 'TN', name: 'Tamil Nadu' },
  { code: 'TG', name: 'Telangana' },
  { code: 'TR', name: 'Tripura' },
  { code: 'UP', name: 'Uttar Pradesh' },
  { code: 'UT', name: 'Uttarakhand' },
  { code: 'WB', name: 'West Bengal' },
  { code: 'AN', name: 'Andaman and Nicobar Islands' },
  { code: 'CH', name: 'Chandigarh' },
  { code: 'DN', name: 'Dadra and Nagar Haveli' },
  { code: 'DD', name: 'Daman and Diu' },
  { code: 'DL', name: 'Delhi' },
  { code: 'LD', name: 'Lakshadweep' },
  { code: 'PY', name: 'Puducherry' }
];
